import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import DataTableToolbar from '../_Shared/DataTables/DataToolbar';
import DataTable from '../_Shared/DataTables/DataTable';
import CreateModal from '../_Shared/CreateModal';
import AppContent from '../_Shared/Layout/AppContent';

const uuidv4 = require('uuid/v4');

class PackageList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showCreateModal: false,
            etlPackage: { name: '' },
            anchorEl: null
        }
        
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleCreateModal = e => {
        const { showCreateModal } = this.state;
        this.setState({ showCreateModal: !showCreateModal, etlPackage: { name: '' } });
    }

    onCreateNew = e => {
        const { etlPackage } = this.state;
        this.props.onPackageAdded(Object.assign({}, etlPackage, { id: uuidv4() }));
        this.setState({ showCreateModal: false });
    }

    handleInputChange = event => {
        const { target: { name, value } } = event;
        this.setState((prevState, state) => {
            return {
                etlPackage: Object.assign({}, prevState.advertiser, { [name]: value, })
            }
        });
    }

    deleteEtlPackage = event => {
        const { etlPackage } = this.state;
        this.props.onPackageRemoved(etlPackage);
        this.setState({ etlPackage: { name: '' }, anchorEl: null });
    }

    selectElement = etlPackage => {
        this.setState({ etlPackage });
    }

    render() {
        const { etlPackages, history } = this.props;
        const { showCreateModal, etlPackage, anchorEl } = this.state;
        return (
            <AppContent>
                <DataTableToolbar title="Packages" numSelected={0} >
                    <Tooltip title="Add New">
                        <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                    </Tooltip>
                </DataTableToolbar>
                <DataTable columns={[{ label: 'Name', field: 'name' }]} anchorEl={anchorEl} rows={etlPackages} toggleRowMenu={this.toggleRowMenu} 
                    onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu}>
                    <MenuItem onClick={() => history.push(`/data-tools/etl-packages/${etlPackage.id}/v${etlPackage.version}/manage`)}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Edit" />
                    </MenuItem>
                    <MenuItem onClick={this.deleteEtlPackage}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
                <CreateModal title="Create Package" open={showCreateModal} closeHandler={this.toggleCreateModal} saveHandler={this.onCreateNew}>
                    <TextField autoFocus value={etlPackage.name} onChange={this.handleInputChange} id="name" name="name" label="Package Name" type="text" fullWidth />
                </CreateModal>
            </AppContent>
        )
    }
}

PackageList.propTypes = {
    etlPackages: PropTypes.array.isRequired
}

export default PackageList


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/PackageList.js